export enum ImageState {
  EMPTY = 'empty',
  ERROR = 'error',
  START = 'start',
  SUCCESS = 'success',
  DENIED = 'denied',
  LOADING = 'loading',
  NO_IMAGE = 'no-image',
  NO_DATA_INTEGRATIONS = 'no-data-integrations',
}
export enum ImageName {
  EMPTY = 'app/webcomponents/assets/images/generic/empty-states_illustration_no-results.svg',
  ERROR = 'app/webcomponents/assets/images/generic/empty-states_illustration_error.svg',
  START = 'app/webcomponents/assets/images/generic/empty-states_illustration_first-use.svg',
  SUCCESS = 'app/webcomponents/assets/images/generic/empty-states_illustration_success.svg',
  DENIED = 'app/webcomponents/assets/images/generic/empty-states_illustration_access_denied.svg',
  LOADING = 'app/webcomponents/assets/images/generic/empty-states_illustration_loading.svg',
  NO_IMAGE = '',
  NO_DATA_INTEGRATIONS = 'app/webcomponents/assets/images/generic/no-data-integrations.svg',
}
